/* ==========================================================================
   WalterGO Reviews Slider - 3D Centered Carousel (Absolute Positioning)
   Shows 3 cards: left (small), center (large), right (small)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
  initReviewsSlider();
});

function initReviewsSlider() {
  const container = document.querySelector('[data-reviews-slider]');
  if (!container) return;

  const wrapper = container.querySelector('.waltergo-reviews__track-wrapper');
  const track = container.querySelector('[data-reviews-track]');
  const cards = track ? Array.from(track.querySelectorAll('.waltergo-review-card')) : [];
  const dots = container.querySelectorAll('[data-reviews-dot]');
  const prevBtn = container.querySelector('[data-reviews-prev]');
  const nextBtn = container.querySelector('[data-reviews-next]');

  if (!track || !wrapper || cards.length === 0) return;

  let currentIndex = 0;

  // Update card positions and states
  function updateCards() {
    const isMobile = window.innerWidth < 750;
    const isTablet = window.innerWidth >= 750 && window.innerWidth < 990;
    const spacing = isMobile ? 300 : isTablet ? 380 : 450;

    cards.forEach((card, index) => {
      // Remove all state classes
      card.classList.remove('is-center', 'is-adjacent', 'is-hidden');

      // Calculate distance from current
      const distance = index - currentIndex;
      const absDistance = Math.abs(distance);

      // Position offset from center
      const offsetX = distance * spacing;

      // Apply state classes
      if (absDistance === 0) {
        card.classList.add('is-center');
        card.style.transform = `translate(calc(-50% + ${offsetX}px), -50%) scale(1)`;
      } else if (absDistance === 1) {
        card.classList.add('is-adjacent');
        card.style.transform = `translate(calc(-50% + ${offsetX}px), -50%) scale(0.85)`;
      } else {
        card.classList.add('is-hidden');
        card.style.transform = `translate(calc(-50% + ${offsetX}px), -50%) scale(0.7)`;
      }
    });
  }

  // Update dots
  function updateDots() {
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === currentIndex);
    });
  }

  // Navigate to slide
  function goToSlide(index) {
    if (index < 0) index = 0;
    if (index >= cards.length) index = cards.length - 1;

    currentIndex = index;
    updateCards();
    updateDots();
  }

  // Navigation
  function nextSlide() {
    goToSlide(currentIndex < cards.length - 1 ? currentIndex + 1 : 0);
  }

  function prevSlide() {
    goToSlide(currentIndex > 0 ? currentIndex - 1 : cards.length - 1);
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToSlide(index));
  });

  // Keyboard support
  document.addEventListener('keydown', (e) => {
    if (!container.contains(document.activeElement)) return;

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextSlide();
    }
  });

  // Touch/swipe
  let touchStartX = 0;
  let touchEndX = 0;

  wrapper.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  wrapper.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  }, { passive: true });

  // Resize handler
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateCards();
    }, 150);
  });

  // Initialize
  setTimeout(() => goToSlide(0), 100);
}

// Shopify theme editor support
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-reviews-slider]')) {
    setTimeout(() => initReviewsSlider(), 100);
  }
});
